/**
 * Labstep
 *
 * @module models/permission-role
 * @desc Typescript export class for PermissionRole
 */

import { Type } from 'class-transformer';
import { Entity } from 'labstep-web/models/entity.model';
import { Organization } from 'labstep-web/models/organization.model';
import { PermissionRoleSetting } from 'labstep-web/models/permission-role-setting.model';

export class PermissionRole extends Entity {
  public static readonly idAttr = 'guid' as const;

  static readonly entityName = 'permission_role' as const;

  get entityName(): string {
    return PermissionRole.entityName;
  }

  constructor(data: Partial<PermissionRole> = {}) {
    super();
    Object.assign(this, data);
  }

  guid!: string;

  name!: string;

  @Type(() => Organization)
  organization!: Organization;

  @Type(() => PermissionRoleSetting)
  permission_role_settings!: PermissionRoleSetting[];
}
